import Vue from 'vue'
import Router from 'vue-router'
import { JWTService } from '@/shared/services/jwt'

// Containers
import PublicBaseLayout from '@/containers/PublicBaseLayout'
import PrivateBaseLayout from '@/containers/PrivateBaseLayout'

// Public Views
import Authentication from '@/views/public/auth/Authentication.vue'
import LostPassword from '@/views/public/auth/lost/LostPassword.vue'

// Privates Views
import StartPage from '@/views/private/StartPage/StartPage.vue'
import Associate from '@/views/private/associate/associate.vue'
import Person from '@/views/private/configurations/person/person.vue'
import Account from '@/views/private/configurations/account/account.vue'
import ChangePassword from '@/views/private/myaccount/profile/profile.vue'
import Employee from '@/views/private/configurations/employee/employee.vue'
import Position from '@/views/private/configurations/position/position.vue'
import PA from '@/views/private/configurations/pa/pa.vue'
import Regional from '@/views/private/configurations/regional/regional.vue'
import Group from '@/views/private/configurations/group/group.vue'
import Links from '@/views/private/configurations/links/links.vue'
import KmValue from '@/views/private/configurations/kmValue/kmValue.vue'
import TiposFinalizacao from '@/views/private/configurations/parametros_atendimento/TiposFinalizacao/tipoFinalizacao.vue'
import QrCode from '@/views/private/configurations/parametros_atendimento/QrCode/qrCode.vue'

import MinhasVisitas from '@/views/private/visitas/minhasVisitas/minhasVisitas.vue'
import EventType from '@/views/private/configurations/eventtype/eventtype.vue'
import ExpenseType from '@/views/private/configurations/expenseType/expenseType.vue'
import Event from '@/views/private/configurations/events/event.vue'
import Product from '@/views/private/configurations/product/product.vue'
import CardMovimentation from '@/views/private/configurations/parametros/cardMovimentation/CardMovimentation.vue'
import MetasGerente from '@/views/private/configurations/parametros/metas-gerente/MetasGerente.vue'
import Import from '@/views/private/import/import.vue'
import Attachments from '@/views/private/attachments/attachments.vue'
import TShield from '@/views/private/tshield/tshield.vue'
import Cluster from '@/views/private/configurations/clusters/clusters.vue'
import ContactExterno from '@/views/private/configurations/contacts/external/contactexternal.vue'
import ContactInternal from '@/views/private/configurations/contacts/internal/contactinternal.vue'
import LinkClusters from '@/views/private/configurations/movimentacoes/clusters/link.vue'
import LinkGerenteRelacionamento from '@/views/private/configurations/movimentacoes/gerentesRelacionamento/link.vue'
import Environment from '@/views/private/configurations/environment/envinronment.vue'
import ChangeMassGerenteRelacionamento from '@/views/private/configurations/movimentacoes/changeMassGerenteRelacionamento/link.vue'
import GiroCarteira from '@/views/private/configurations/movimentacoes/giroCarteira/GiroCarteira.vue'

import Cobranca from '@/views/private/cobranca/cobranca.vue'
import CobrancaUpdates from '@/views/private/cobranca/cobrancaUpdates.vue'
import CRM from '@/views/private/crm/crm.vue'
import CrmBoard from '@/views/private/crm/board/board.vue'
import CrmDetails from '@/views/private/crm/details/crmdetails.vue'
import AssociateDetails from '@/views/private/associate/components/associatedetails.vue'
import CrmCardLost from '@/views/private/crm/card/lost/lostcard.vue'
import CrmCardWon from '@/views/private/crm/card/won/cardwon.vue'
import CrmCardFinished from '@/views/private/crm/card/finish/cardfinished.vue'
import Origin from '@/views/private/configurations/origem/origin.vue'
import Reason from '@/views/private/configurations/board/reason/reason.vue'

import Campaign from '@/views/private/campaign/campaign.vue'
import CampaignTemplate from '@/views/private/configurations/campaign/templates/campanhamodelo.vue'
import CampaignSegmentation from '@/views/private/configurations/campaign/campaignlist/campaignlist.vue'
import CampaignSocialMedia from '@/views/private/campaign/components/socialmedia/campanharedesocial.vue'
import WhatsappConfig from '@/views/private/configurations/campaign/whatsapp/whatsappconfig.vue'

import EmailEnvio from '@/views/private/configurations/email/emailenvio.vue'

import ReportCrm from '@/views/private/reports/crm/reportcrm.vue'
import ReportCampanha from '@/views/private/reports/campanha/campanhaGeral/reportCampanha.vue'
import ReportEnvioCampanha from '@/views/private/reports/campanha/envioCampanha/reportEnvioCampanha.vue'
import ReportFollowUp from '@/views/private/reports/followup/ReportFollowUp.vue'

import Visitas from '@/views/private/visitas/visitas.vue'
import VisitasDeslocamento from '@/views/private/visitas/deslocamento/deslocamento.vue'
import VisitasDeslocamentoPontoInicial from '@/views/private/visitas/deslocamento/pontos/pontoinicial.vue'
import VisitasDeslocamentoPontoFinal from '@/views/private/visitas/deslocamento/pontos/pontofinal.vue'
import TiposVisitas from '@/views/private/configurations/visit-type/tiposVisitas.vue'
// import VisitasDeslocamentoCheckOut from '@/views/private/visitas/deslocamento/modal/checkout/checkout.vue'
import VisitasDeslocamentoCheckIn from '@/views/private/visitas/deslocamento/register/checkin.vue'
import VisitasDeslocamentoFollowUp from '@/views/private/visitas/deslocamento/followup.vue'
import VisitasRelatorioDeslocamento from '@/views/private/visitas/reports/deslocamento/ReportDeslocamento.vue'
import VisitasRelatorioDespesas from '@/views/private/visitas/reports/despesas/ReportDespesas.vue'

import NewCapitalAccountParams from '@/views/private/configurations/parametros/newCapitalAccountParams/NewCapitalAccountParams.vue'
import VisitasRelatorioAcompanhamento from '@/views/private/visitas/reports/acompanhamento/ReportAcompanhamento.vue'
import SerasaParams from '@/views/private/configurations/parametros/SerasaParams/SerasaParams.vue'
import NewClasseAParams from '@/views/private/configurations/parametros/classeA/NewClasseAParams.vue'
import ViewbParams from '@/views/private/configurations/parametros/viewb/ViewbParams.vue'
import WhatsappParams from '@/views/private/configurations/parametros/whatsapp/DisparoWhatsappParams.vue'
import EncurtadorConfig from '@/views/private/configurations/parametros/encurtador/encurtadorconfig.vue'
import OpenCardsVisitasParams from '@/views/private/configurations/parametros/visitas/aberturaCard/OpenCardsVisitasParams.vue'
import RegistroBot from '@/views/private/configurations/parametros_atendimento/registroBot/RegistroBot.vue'

import Assunto from '@/views/private/configurations/ajuizamento/assunto/assunto.vue'
import Comarca from '@/views/private/configurations/ajuizamento/comarca/comarca.vue'
import Fase from '@/views/private/configurations/ajuizamento/fase/fase.vue'
import ObjetoAcao from '@/views/private/configurations/ajuizamento/objetoacao/objetoacao.vue'
import Prognostico from '@/views/private/configurations/ajuizamento/prognostico/prognostico.vue'

import Atendimento from '@/views/private/atendimento/atendimento.vue'
import ListaInteligente from '@/views/private/configurations/lista-inteligente/ListaInteligente.vue'
import CentralAtendimento from '@/views/private/atendimento/central_atendimento/centralAtendimento.vue'
import CentralAtendimentoGeral from '@/views/private/atendimento/central_atendimento_geral/centralAtendimento.vue'
import HistoricoAtendimento from '@/views/private/atendimento/historico_atendimento/historicoAtendimento.vue'
import HorarioAtendimento from '@/views/private/configurations/parametros_atendimento/horarioAtendimento/horarioAtendimento.vue'
import MensagensAutomaticas from '@/views/private/configurations/parametros_atendimento/mensagensautomaticas/mensagensautomaticas.vue'

import Hsm from '@/views/private/configurations/hsm/Hsm.vue'

Vue.use(Router)

/**
 * @function assertLoggedIn
 * @description Middleware para ser executado antes da troca de rota para garantir
 * que os usuários estão autenticados para ver esta rota.
 * @param {Object} to A rota de onde o usuário está vindo.
 * @param {Object} from A rota que o usuário deseja acessar.
 * @param {Object} next A rota que será renderizada.
 */
const assertLoggedIn = (to, from, next) => {
  if (!JWTService.GetToken()) {
    next({ name: 'SignIn' })
    return
  }
  next()
}
/**
 * @function assertNotLoggedIn
 * @description Middleware para ser executado antes da troca de rota para garantir
 * que os usuários não estão autenticados para ver esta rota.
 * @param {Object} to A rota de onde o usuário está vindo.
 * @param {Object} from A rota que o usuário deseja acessar.
 * @param {Object} next A rota que será renderizada.
 */
const assertNotLoggedIn = (to, from, next) => {
  if (JWTService.GetToken()) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertIsAdministrator = (to, from, next) => {
  if (!JWTService.GetRoles().includes('ADMINISTRADOR')) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertHasAcessoCampanha = (to, from, next) => {
  if (!JWTService.GetRoles().includes('ACESSO_CAMPANHA')) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertHasAcessoRelatorio = (to, from, next) => {
  if (!JWTService.GetRoles().includes('ACESSO_RELATORIOS')) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertHasMovimentacaoPermission = (to, from, next) => {
  if (!JWTService.GetRoles().includes('MOVIMENTACAO')) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertHasModuleKanban = (to, from, next) => {
  if (!process.env.hasKanban) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertIsAdministratorAndHasModuleKanban = (to, from, next) => { // TODO: Refatorar essa funcao
  if (!JWTService.GetRoles().includes('ADMINISTRADOR')) {
    next({ name: 'PaginaInicial' })
    return
  }
  if (!process.env.hasKanban) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertIsAtendimento = (to, from, next) => { // TODO: Refatorar essa funcao
  if (!JWTService.GetRoles().includes('ADMINISTRADOR') && !JWTService.GetRoles().includes('OPERADOR_ATENDIMENTO_GERAL')) {
    next({ name: 'PaginaInicial' })
    return
  }
  if (!process.env.hasAtendimento) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}

const assertIsAtendimentoGeral = (to, from, next) => { // TODO: Refatorar essa funcao
  if (!JWTService.GetRoles().includes('ADMINISTRADOR') && !JWTService.GetRoles().includes('OPERADOR_ATENDIMENTO')) {
    next({ name: 'PaginaInicial' })
    return
  }
  if (!process.env.hasAtendimento) {
    next({ name: 'PaginaInicial' })
    return
  }
  next()
}
/**
 * @function route
 * @description Cria um objeto de rota.
 * @param {string} path O caminho da rota.
 * @param {string} name O nome da rota.
 * @param {Object} component O componente a ser renderizado na rota.
 * @param {Array} children As children routes desta rota.
 * @returns {Object} Um objeto de rota do vue-router.
 */
const route = (path, name, component, children, beforeEnter, meta) => ({
  path,
  name,
  component,
  children,
  beforeEnter,
  meta
})

/**
 * @function children
 * @description Transforma um objetos com rotas em array.
 * @param {...} routes As rotas para serem retornadas em forma de array.
 * @returns {Array} O array com as rotas.
 */
const children = (...routes) => routes

/**
 * @property adminRoutes
 * @description As rotas privadas da aplicação.
 * @type {Object}
 */
const adminRoutes = {
  path: '/',
  redirect: '/pagina-inicial',
  component: PrivateBaseLayout,
  beforeEnter: assertLoggedIn,
  children: children(
    route('/pagina-inicial', 'PaginaInicial', StartPage),
    route('/associados', 'Associate', Associate),
    route('/associados/:associateId', 'DetalhesAssociate', AssociateDetails, null, assertHasModuleKanban, { removeContainer: false }),
    route('/conta/alterar-senha', 'AlterarSenha', ChangePassword),
    route('/importacao', 'Importacao', Import, null, assertIsAdministrator),
    route('/anexos', 'Anexos', Attachments),
    route('/cadastro/usuarios', 'Contas', Account, null, assertIsAdministrator),
    route('/cadastro/organizacao/pessoa', 'Pessoa', Person, null, assertIsAdministrator),
    // route('/cadastro/organizacao/gerentes', 'Gerentes', Manager, null, assertIsAdministrator),
    route('/cadastro/organizacao/funcionarios', 'Funcionarios', Employee, null, assertIsAdministrator),
    route('/cadastro/organizacao/cargos', 'Cargos', Position, null, assertIsAdministrator),
    route('/cadastro/organizacao/pa', 'PA', PA, null, assertIsAdministrator),
    route('/cadastro/organizacao/regional', 'Regional', Regional, null, assertIsAdministrator),
    route('/cadastro/organizacao/grupo', 'Grupo', Group, null, assertIsAdministrator),
    route('/cadastro/organizacao/clusterizacao', 'Cluster', Cluster, null, assertIsAdministrator),
    route('/cadastro/links', 'Links', Links, null, assertIsAdministrator),
    route('/cadastro/followup/valor-km', 'ValorKm', KmValue, null, assertIsAdministrator),
    route('/cadastro/parametros_atendimento/parametros_finalizacao', 'ParametrosFinalizacao', TiposFinalizacao, null, assertIsAtendimento),
    route('/cadastro/parametros_atendimento/horarioatendimento', 'HorarioAtendimento', HorarioAtendimento, null, assertIsAtendimento),
    route('/cadastro/parametros_atendimento/mensagensautomaticas', 'MensagensAutomaticas', MensagensAutomaticas, null, assertIsAtendimento),
    route('/cadastro/parametros_atendimento/qrcode', 'QrCode', QrCode, null, assertIsAtendimento),
    route('/cadastro/parametros_atendimento/registroBot', 'RegistroBot', RegistroBot, null, assertIsAtendimento),
    route('/cadastro/followup/tipo-de-evento', 'TipoEvento', EventType, null, assertIsAdministrator),
    route('/cadastro/followup/tipo-de-despesa', 'TipoDespesa', ExpenseType, null, assertIsAdministrator),
    route('/cadastro/followup/eventos', 'Evento', Event, null, assertIsAdministrator),
    route('/analise', 'CadastroTShield', TShield),
    route('/cadastro/contatos/externo', 'ContatoExterno', ContactExterno, null, assertIsAdministrator),
    route('/cadastro/contatos/interno', 'ContatoInterno', ContactInternal, null, assertIsAdministrator),
    route('/cadastro/movimentacao/agenteRelacionamento', 'LinkGerenteRelacionamento', LinkGerenteRelacionamento, null, assertHasMovimentacaoPermission),
    route('/cadastro/movimentacao/cluster', 'LinkClusters', LinkClusters, null, assertHasMovimentacaoPermission),
    route('/cadastro/movimentacao/mudarAgentes', 'ChangeMassGerenteRelacionamento', ChangeMassGerenteRelacionamento, null, assertHasMovimentacaoPermission),
    route('/cadastro/movimentacao/giroCarteira', 'GiroCarteira', GiroCarteira, null, assertHasMovimentacaoPermission),
    route('/cadastro/quadro/origem', 'OrigemLead', Origin, null, assertIsAdministratorAndHasModuleKanban),
    route('/cadastro/quadro/motivo', 'Motivo', Reason, null, assertIsAdministratorAndHasModuleKanban),
    route('/cadastro/quadro/produto', 'Produto', Product, null, assertIsAdministratorAndHasModuleKanban),
    route('/cadastro/modelos/campanha', 'CampanhaModelo', CampaignTemplate, null, assertHasAcessoCampanha),
    route('/cadastro/campanha/whatapp', 'WhatsappConfig', WhatsappConfig, null, assertIsAdministrator),
    route('/cadastro/campanha/lista-de-contatos', 'CampanhaLista', CampaignSegmentation, null, assertHasAcessoCampanha),
    route('/configuracao/environment', 'Environment', Environment, null, assertIsAdministrator),
    route('/cobranca', 'Cobrança', Cobranca, null, assertHasModuleKanban), // WAIT FOR BACK-END PERMISSION TO SHOW/HIDE
    route('/cobranca/atualizacoes', 'CobrançaUpdates', CobrancaUpdates, null, assertHasModuleKanban), // WAIT FOR BACK-END PERMISSION TO SHOW/HIDE
    route('/crm', 'CRM', CRM, null, assertHasModuleKanban),
    route('/crm/quadro/:boardId', 'Quadro', CrmBoard, null, assertHasModuleKanban, { removeContainer: true }),
    route('/crm/quadro/:boardId/lead/:cardId', 'DetalhesLead', CrmDetails, null, assertHasModuleKanban, { removeContainer: true }),
    route('/crm/quadro/:boardId/ganho', 'CardGanho', CrmCardWon, null, assertHasModuleKanban, { removeContainer: true }),
    route('/crm/quadro/:boardId/perdido', 'CardPerdido', CrmCardLost, null, assertHasModuleKanban, { removeContainer: true }),
    route('/crm/quadro/:boardId/finalizado', 'CardFinalizado', CrmCardFinished, null, assertHasModuleKanban, { removeContainer: true }),
    route('/campanha', 'Campanha', Campaign, null, assertHasAcessoCampanha),
    route('/campanha/redesocial', 'RedeSocial', CampaignSocialMedia, null, assertHasAcessoCampanha),
    route('/emailenvio', 'EmailEnvio', EmailEnvio, null, assertIsAdministrator),
    route('/visitas', 'Visitas', Visitas, null, null),
    route('/visitas/deslocamento', 'Deslocamento', VisitasDeslocamento, null, null),
    route('/visitias/deslocamento/pronto/inicial', 'DeslocamentoPontoInicial', VisitasDeslocamentoPontoInicial, null, null),
    route('/visitas/deslocamento/pronto/final', 'DeslocamentoPontoFinal', VisitasDeslocamentoPontoFinal, null, null),
    // route('/visitas/deslocamento/checkout', 'DeslocamentoCheckout', VisitasDeslocamentoCheckOut, null, null),
    route('/visitas/minhas-visitas', 'MinhasVisitas', MinhasVisitas, null, null),
    route('/visitas/deslocamento/checkin', 'DeslocamentoCheckin', VisitasDeslocamentoCheckIn, null, null),
    route('/visitas/deslocamento/follow-up', 'FollowUp', VisitasDeslocamentoFollowUp, null, null),
    route('/visitas/tipos-visitas', 'TiposVisitas', TiposVisitas, null, null),
    route('/relatorios/visitas/deslocamento', 'RelatorioDeslocamento', VisitasRelatorioDeslocamento, null, assertHasAcessoRelatorio),
    route('/relatorios/visitas/despesas', 'RelatorioDespesas', VisitasRelatorioDespesas, null, assertHasAcessoRelatorio),
    route('/relatorios/visitas/acompanhamento', 'RelatorioAcompanhamento', VisitasRelatorioAcompanhamento, null, assertHasAcessoRelatorio),
    route('/relatorios/crm', 'RelatorioCrm', ReportCrm, null, assertHasAcessoRelatorio),
    route('relatorios/follow-up', 'RelatorioFollowUp', ReportFollowUp, null, assertHasAcessoRelatorio),
    route('/cadastro/ajuizamento/assunto', 'Assunto', Assunto, null, assertIsAdministrator),
    route('/cadastro/ajuizamento/comarca', 'Comarca', Comarca, null, assertIsAdministrator),
    route('/cadastro/ajuizamento/fase', 'Fase', Fase, null, assertIsAdministrator),
    route('/cadastro/ajuizamento/objetoacoa', 'ObjetoAcao', ObjetoAcao, null, assertIsAdministrator),
    route('/cadastro/ajuizamento/prognostico', 'Prognostico', Prognostico, null, assertIsAdministrator),
    route('/relatorios/campanha', 'RelatorioCampanha', ReportCampanha, null, assertHasAcessoCampanha),
    route('/relatorios/envio-campanha', 'ReportEnvioCampanha', ReportEnvioCampanha, null, assertHasAcessoCampanha),
    route('/cadastro/parametros/card-nova-conta-capital', 'ContaCapitalParametros', NewCapitalAccountParams, null, assertIsAdministrator),
    route('/cadastro/parametros/serasa', 'SerasaParams', SerasaParams, null, assertIsAdministrator),
    route('/cadastro/parametros/movimentacao', 'MovimentacaoConta', CardMovimentation, null, assertIsAdministratorAndHasModuleKanban),
    route('/cadastro/parametros/metas-gerente', 'MetasGerente', MetasGerente, null, assertIsAdministratorAndHasModuleKanban),
    route('/cadastro/parametros/classe-a', 'ClasseAParametros', NewClasseAParams, null, assertIsAdministrator),
    route('/cadastro/parametros/viewb', 'ViewbParametros', ViewbParams, null, assertIsAdministrator),
    route('/cadastro/parametros/whatsapp', 'WhatsappParams', WhatsappParams, null, assertIsAdministrator),
    route('/cadastro/parametros/encurtador', 'EncurtadorConfig', EncurtadorConfig, null, assertIsAdministrator),
    route('/cadastro/parametros/card-visitas', 'AberturaDeCardVisitas', OpenCardsVisitasParams, null, assertIsAdministrator),
    route('/atendimento', 'Atendimento', Atendimento, null, assertIsAtendimento, { removeContainer: true }),
    route('/atendimento/historico', 'HistoricoAtendimento', HistoricoAtendimento, null, null, { removeContainer: true }),
    route('/configuracoes/lista-inteligente', 'ListaInteligente', ListaInteligente, null, null),
    route('/cadastro/modelos/hsm', 'Hsm', Hsm, null, assertIsAdministrator),
    route('/atendimento/centralGeral', 'CentralAtendimentoGeral', CentralAtendimentoGeral, null, assertIsAtendimentoGeral, { removeContainer: true }),
    route('/atendimento/central', 'CentralAtendimento', CentralAtendimento, null, assertIsAtendimento, { removeContainer: true }),
    route('/configuracoes/lista-inteligente', 'ListaInteligente', ListaInteligente, null, null)
  )
}

/**
 * @property publicRoutes
 * @description As rotas públicas da aplicação. (Não requerem autenticação)
 * @type {Object}
 */

const publicRoutes = {
  path: '/',
  redirect: '/login',
  component: PublicBaseLayout,
  children: children(
    route('/login', 'SignIn', Authentication, null, assertNotLoggedIn),
    route('/redefinir-senha', 'LostPassword', LostPassword, null, assertNotLoggedIn),
    route('/redefinir-senha/token/:token', 'ChangePassword', ChangePassword, null, assertNotLoggedIn)
  )
}

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    publicRoutes,
    adminRoutes,
    {
      path: '*',
      component: PublicBaseLayout
    },
    {
      'method': 'GET',
      'path': '/static/fonts/:file',
      'type': 'passthrough',
      'service': 'static/fonts/:file'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js